import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent { }
